import { breakpoints, theme } from '@notino/react-styleguide';

import { styled } from '@linaria/react';

export const Container = styled.div`
  padding: 1rem 0;
`;

export const IconTextWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 1rem;
  gap: 0.25rem;

  @media screen and (min-width: ${breakpoints.sm}) {
    padding-right: 0.5rem;
  }
`;

export const CampaignsWrapper = styled.div`
  @media (min-width: ${breakpoints.md}) {
    overflow: visible;
  }
`;

export const CollapsibleItemsContainerWrapper = styled.div`
  display: none;

  @media (min-width: ${breakpoints.md}) {
    display: flex;
    flex-direction: column;
    gap: 1rem;

    button {
      text-decoration-line: underline;
      width: fit-content;
    }
  }
`;

export const GiftBaseItemWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  border: 1px solid ${theme.color.border.divider};
  border-radius: 0.25rem;

  @media (min-width: ${breakpoints.md}) {
    flex-direction: row;
    border: none;
    gap: 0.75rem;
  }
`;

export const CampaignsStyled = styled.div<{ isOneCampaign: boolean }>`
  display: flex;
  gap: 1rem;
  overflow: scroll;
  -webkit-overflow-scrolling: touch;

  div {
    width: ${({ isOneCampaign }) => (isOneCampaign ? '100%' : '18rem')};
  }

  @media (min-width: ${breakpoints.md}) {
    display: none;

    div {
      width: 100%;
    }
  }
`;

export const TooltipWrapper = styled.div`
  display: none;

  @media (min-width: ${breakpoints.md}) {
    display: block;
  }
`;

export const Title = styled.div<{ isMonochrome: boolean }>`
  color: ${({ isMonochrome }) =>
    isMonochrome ? theme.color.text.primary : theme.color.text.highlight};

  ${theme.typography.labelRegular}
`;

export const Description = styled.div`
  padding: 1rem;
  padding-bottom: 1.5rem;

  a {
    color: ${theme.color.text.primary};
    text-decoration: underline;
  }
  a:hover {
    text-decoration: none;
  }

  ${theme.typography.bodyRegular}

  @media (min-width: ${breakpoints.md}) {
    flex-direction: row;
    border: none;
    padding: 0rem;
  }
`;

export const GiftCount = styled.span`
  color: ${theme.color.text.tertiary};
  margin-left: 0.25rem;
`;

export const GiftIconWrapper = styled.div`
  padding-right: 0.25rem;
`;

export const GiftContent = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;

  @media (min-width: ${breakpoints.md}) {
    flex: 1;
  }
`;

export const LoyaltyLabel = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  align-self: flex-start;
  width: auto !important;

  margin: 1rem 1rem 0;
  padding: 0.25rem 0.5rem;

  background-color: ${theme.color.loyalty.lightBlue};
  border-radius: 0.25rem;

  color: ${theme.color.text.primary};
  ${theme.typography.labelSmall}

  svg {
    flex-shrink: 0;
    width: 1rem;
    height: 1rem;
  }

  @media (min-width: ${breakpoints.md}) {
    margin: 0 0 0.5rem;
  }
`;

export const TooltipContent = styled.div`
  width: 14rem;
  text-align: center;

  @media (min-width: ${breakpoints.md}) {
    min-width: 16rem;
  }
`;
